import { DictionaryBaseService } from '@/app/shared/services/dictionary-base.service';
import { Injectable } from '@angular/core';
import { IStep } from './step.model';
import { GlobalRef } from '@/app/shared/globals/global-ref';
import { UserContextService } from '@/app/shared/services/user-context.service';
import { HttpClient } from '@angular/common/http';
import { IEntityValidation } from '@/app/shared/interfaces/models/ientity-validation.model';

@Injectable({
  providedIn: 'root',
})
export class StepService extends DictionaryBaseService<IStep> {
  constructor(
    globalContext: GlobalRef,
    protected userContextSvc: UserContextService,
    protected http: HttpClient
  ) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += 'Steps/';
  }

  validate(model: IStep): IEntityValidation {
    const res: IEntityValidation = { Valid: true, FieldErrors: {} };
    const fieldErrors = res.FieldErrors!;
    if (!model.Title || model.Title.trim().length <= 0) {
      fieldErrors['Title'] = 'Введите название';
    }
    if (!model.Order) {
      fieldErrors['Order'] = 'Порядок не указан';
    }

    if (Object.keys(fieldErrors).length > 0) {
      res.Valid = false;
      res.Message = Object.values(fieldErrors).join('.<br>') + '.';
    }
    return res;
  }
}
